module.exports = __webpack_public_path__ + "img/THU-LOGO-ORANGE-FINAL_kicsi-300x132.f24f9024.png";